import * as uuid from 'uuid';
import { type FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form } from 'react-bootstrap';

import ModalWindow from '@editor2/components/ModalWindow';
import { addPageGroupToChapter } from '@editor2/reducers/editor/editorSlice';

interface Props {
	chapterId: string;
	index?: number;
	isShown: boolean;
	courseId: number;
	onHide: () => void;
}

const AddPageGroupModal: FC<Props> = (props) => {
	const { chapterId, index, isShown, courseId, onHide } = props;

	const dispatch = useDispatch();
	const [pageGroupName, setPageGroupName] = useState('');

	const handleInputChange = (value: string) => {
		setPageGroupName(value);
	};

	const addPageGroup = () => {
		const pageGroupEntity = {
			family_id: uuid.v4(),
			name: pageGroupName,
			type: 'NG::Traditional::PageGroup',
			pages: []
		};
		dispatch(addPageGroupToChapter({ chapterId, pageGroupEntity, index, courseId }));

		onHide();
	};

	const title = <div>Add new page group</div>;

	const footer = (
		<Button variant="success" size="sm" disabled={!pageGroupName} onClick={addPageGroup}>
			Add
		</Button>
	);

	return (
		<ModalWindow isShown={isShown} onHide={onHide} title={title} footer={footer}>
			<Form.Group>
				<Form.Label>Page group name</Form.Label>
				<Form.Control
					placeholder="Enter page group name"
					onChange={(e) => handleInputChange(e.target.value)}
				/>
			</Form.Group>
		</ModalWindow>
	);
};

export default AddPageGroupModal;
